import React from 'react';
import {Link} from 'react-router-dom';
import {ArrowRight, BookOpen, Clock} from 'lucide-react';
const guides = require('../seo/guides.json');

export const GuidesHighlight = () => {
  const entries = Object.values(guides).slice(0, 3);
  if (entries.length === 0) return null;

  return (
    <section data-testid="home-guides" className="py-16 bg-white">
      <div className="max-w-6xl mx-auto px-4">
        <div className="flex flex-wrap items-end justify-between gap-4 mb-10">
          <div>
            <p className="flex items-center gap-2 text-green-700 text-sm font-semibold uppercase tracking-wide mb-2">
              <BookOpen size={16} />Guides pratiques
            </p>
            <h2 className="text-2xl font-bold text-slate-800">Préparez votre chantier avant de réserver</h2>
            <p className="text-slate-600 text-sm md:text-base mt-2 max-w-2xl">
              Méthode étape par étape, matériel utile et erreurs à éviter : ce que nous expliquons au dépôt, écrit noir sur blanc.
            </p>
          </div>
          <Link
            to="/guides"
            data-testid="home-guides-all-link"
            className="inline-flex items-center gap-2 text-green-700 hover:text-green-800 transition-colors font-semibold"
          >
            Tous les guides <ArrowRight size={16} />
          </Link>
        </div>

        <div className={`grid gap-6 ${entries.length >= 3 ? 'md:grid-cols-3' : 'sm:grid-cols-2'}`}>
          {entries.map(guide => (
            <Link
              key={guide.slug}
              to={`/guides/${guide.slug}`}
              data-testid={`home-guide-${guide.slug}`}
              className="group bg-slate-50 border border-slate-100 rounded-xl overflow-hidden hover:border-green-300 hover:shadow-lg transition-all"
            >
              <div className="overflow-hidden">
                <img
                  src={guide.image}
                  alt={guide.h1}
                  loading="lazy"
                  className="w-full h-40 object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5">
                <p className="text-xs font-semibold uppercase tracking-wide text-green-700 mb-2">{guide.category}</p>
                <h3 className="font-bold text-slate-800 mb-2 line-clamp-2">{guide.h1}</h3>
                <p className="text-sm text-slate-600 line-clamp-2">{guide.description}</p>
                <p className="mt-4 flex items-center justify-between text-sm">
                  <span className="flex items-center gap-1 text-slate-500"><Clock size={14} />{guide.readTime}</span>
                  <span className="text-green-700 font-semibold">Lire le guide →</span>
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default GuidesHighlight;
